<template>
  <!-- 会员管理 -->
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="会员账号">
          <a-input v-model="userid" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search()" v-if="role81">搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="onEdit(undefined)" v-if="role55">添加会员</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="danger" @click="checkDelete()" v-if="role57">批量删除</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="danger" @click="AllDelete()" v-if="role57">删除所有</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="orderexport('ALL')" v-if="role80">导出所有会员</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="orderexportbatchshow()" v-if="role80">批量导出会员</a-button>
        </a-form-item>
      </a-form>
    </div>
    <br />
    <a-table size="middle" :columns="columns" row-key="User" :data-source="data" :pagination="false" :loading="loading"
      bordered :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }">
      <template slot="CreditAmount" slot-scope="text, record">
        <a @click="JumpRoute(record.User)">{{ text }}</a>
      </template>
      <template slot="SumBorrowing" slot-scope="text, record">
        <a @click="HistoryRoute(record.User,'1')">{{ text }}</a>
      </template>
      <template slot="SumRepay" slot-scope="text, record">
        <a @click="HistoryRoute(record.User,'2')">{{ text }}</a>
      </template>
      <template slot="operate" slot-scope="text, record">
        <a-tooltip v-if="role55">
          <template slot="title"> 编辑 </template>
          <a href="javascript:;" @click="onEdit(record)">
            <a-icon type="edit" style="font-size: 22px"></a-icon>
          </a>
        </a-tooltip>
        <span v-if="role55">&nbsp;</span>
        <a-tooltip v-if="role56">
          <template slot="title"> 删除 </template>
          <a-popconfirm title="确定要删除?" @confirm="() => onDelete(record)">
            <a href="javascript:;">
              <a-icon type="delete" style="font-size: 22px"></a-icon>
            </a>
          </a-popconfirm>
        </a-tooltip>
      </template>
    </a-table>
    <div style="margin: 16px 0;height: 8px;">
      <a-pagination style="float:right;" show-size-changer :default-current="pagination.current"
        :total="pagination.total" :show-total="total => `共 ${total} 条`" :pageSizeOptions="pagination.sizeList"
        @change="pageNumberChange" @showSizeChange="sizeChange" />
    </div>
    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" title="编辑" @ok="modalOk">
      <a-form-model ref="ruleForm" :rules="rules" :model="formModel" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item has-feedback label="会员账号" ref="User" prop="User">
          <a-input v-model="formModel.User" placeholder="会员账号" :readOnly="modelUser" />
        </a-form-model-item>
        <a-form-model-item has-feedback label="电子等级" ref="SlotLevel" prop="SlotLevel">
          <a-input v-model.number="formModel.SlotLevel" />
        </a-form-model-item>
        <a-form-model-item has-feedback label="真人等级" ref="LiveLevel" prop="LiveLevel">
          <a-input v-model.number="formModel.LiveLevel" />
        </a-form-model-item>
        <br>
        <a style="color:red">*请留意电子或真人排行榜设定的会员等级里的借支金额是否有设置,将会影响会员最高借款额度!!!!</a>
        <br><br>
      </a-form-model>
    </a-modal>

    <!-- 批量导出对话框 ------------------------------------->
    <a-modal v-model="exportbatchvisible" title="批量导出" @ok="orderexport('Batch')">
      <a-form-model>
        <a-form-model-item label="指定导出页数">
          <a-input v-model="exportpageindex" />
        </a-form-model-item>
        <a-form-model-item label="设定每页最大笔数">
          <a-input v-model="exportpagesize" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 对话框 --------------------------------------------------------------------------------------------------------->

  </a-layout-content>
</template>
<script>
  import XLSX from "xlsx";
  import moment from "moment";
  import { jsonExportSheet } from "../../js/xlsxTool";
  import { isSpecialStr, isNumber } from "../../js/textverify";

  export default {
    data() {
      return {
        role55: false,
        role56: false,
        role57: false,
        role80: false,
        role81: false,
        visible: false, //弹框状态
        exportbatchvisible: false, //批量导出弹窗
        formModel: {}, // 弹框字段
        modelUser: true,
        labelCol: { span: 5 },
        wrapperCol: { span: 14 },
        userid: undefined,
        exportpageindex: 0,
        exportpagesize: 0,
        selectedRowKeys: [],
        data: [],
        columns: [
          {
            title: "用户名",
            dataIndex: "User",
            align: "center",
          },
          {
            title: "电子等级",
            dataIndex: "SlotLevel",
            align: "center",
            width: '50px',
          },
          {
            title: "电子信用额度",
            dataIndex: "SlotAmount",
            align: "center",
          },
          {
            title: "真人等级",
            dataIndex: "LiveLevel",
            align: "center",
            width: '50px',
          },
          {
            title: "真人信用额度",
            dataIndex: "LiveAmount",
            align: "center",
          },
          {
            title: "信用借支",
            dataIndex: "CreditAmount",
            align: "center",
            scopedSlots: { customRender: "CreditAmount" },
          },
          {
            title: "最高借款",
            dataIndex: "MaxAmount",
            align: "center",
          },
          {
            title: "当前未还款金额",
            dataIndex: "RestAmount",
            align: "center",
          },
          {
            title: "可借款额度",
            dataIndex: "AlreadyAmount",
            align: "center",
          },
          {
            title: "总成功借款",
            dataIndex: "SumBorrowing",
            align: "center",
            scopedSlots: { customRender: "SumBorrowing" },
          },
          {
            title: "总成功还款",
            dataIndex: "SumRepay",
            align: "center",
            scopedSlots: { customRender: "SumRepay" },
          },
          {
            title: "操作",
            dataIndex: "operate",
            align: "center",
            scopedSlots: { customRender: "operate" },
          },
        ],
        pagination: {
          current: 1, pageSize: 10, total: 0,
          sizeList: ['10', '20', '30', '40', '50'],
        },
        loading: false,
        type: 1,
        rules: {
          User: [
            { required: true, message: '请输入会员账号', trigger: 'blur' },
            { min: 1, max: 20, message: '长度应该是1到20', trigger: 'blur' },
            { validator: isSpecialStr, trigger: 'change' },
          ],
          SlotLevel: [
            { required: true, message: '请输入电子等级', trigger: 'blur' },
            { validator: isNumber, trigger: 'change' },
          ],
          LiveLevel: [
            { required: true, message: '请输入真人等级', trigger: 'blur' },
            { validator: isNumber, trigger: 'change' },
          ],
        }
      };
    },
    methods: {
      moment,
      //分页页数的改变
      pageNumberChange(current, size) {
        this.pagination.current = current;
        this.pagination.pageSize = size;
        this.qryListAPI();
      },
      //  分页显示条数的变化
      sizeChange(current, size) {
        this.pagination.current = current;
        this.pagination.pageSize = size;
        this.qryListAPI();
      },
      // 搜索
      search() {
        this.pagination.current = 1;
        this.qryListAPI();
      },
      //页面跳转
      JumpRoute(obj) {
        this.$router.push({
          name: 'creditadvance',
          params: {
            name: "creditadvance",
            userid: obj
          }
        });
      },
      HistoryRoute(obj, type) {
        this.$router.push({
          name: 'orderhistory',
          params: {
            name: 'orderhistory',
            userid: obj,
            type: type
          }
        });
      },
      // 编辑
      onEdit(data) {
        this.visible = true;
        this.$refs['ruleForm'].resetFields();
        if (data === undefined) { //添加
          this.formModel = {};
          this.formModel.Type = 1;
          this.modelUser = false;
        }
        else { //编辑
          this.formModel = { ...data };
          this.modelUser = true;
          this.formModel.Type = 0;
        }
      },
      // 编辑确认
      modalOk() {
        // 弹框确认动作
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            this.axios.post("/UserMember/SaveUserMember", {
              UserID: this.formModel.User,
              SlotID: this.formModel.SlotLevel,
              LiveID: this.formModel.LiveLevel,
              Type: this.formModel.Type,
            }).then((res) => {
              if (res.data) {
                this.$message.success("编辑成功");
                this.qryListAPI();
                this.visible = false;
              }
            });
          }
        });
      },
      // 删除
      onDelete(data) {
        this.axios
          .post("/UserMember/DeleteUserMember", { UserID: data.User })
          .then((res) => {
            if (res.data) {
              this.$message.success("删除成功");
              this.qryListAPI();
            }
          });
      },
      // 删除所有
      AllDelete() {
        const that = this;
        this.$confirm({
          title: "批量删除",
          content: "您要确定要删除所有吗?",
          onOk() {
            that.axios
              .post("/UserMember/AllDeleteUserMember", {
                Type: that.type,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success("删除成功");
                  that.qryListAPI();
                }
              });
          },
        });
      },
      // 数据导出
      orderexport(flag) {
        let today = new Date();
        let params;
        if (flag == 'ALL') {
          params = {
            User: this.userid == undefined ? "" : this.userid
          };
        }
        else {
          params = {
            User: this.userid == undefined ? "" : this.userid,
            pageindex: this.exportpageindex,
            pagesize: this.exportpagesize
          };
        }
        this.axios({
          url: flag == 'ALL' ? "/UserMember/ExportUserMemberList" : "/UserMember/ExportUserMemberListBatch",
          method: "get",
          params: params,
          responseType: "blob",
        }).then((response) => {
          let blob = new Blob([response.data], { type: response.data.type });
          // 针对于 IE 浏览器的处理, 因部分 IE 浏览器不支持 createObjectURL
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // 创建下载的链接
            downloadElement.href = href;
            downloadElement.download =
              "借呗会员列表- " + today.toISOString().split("T")[0]; // 下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
            window.URL.revokeObjectURL(href); // 释放掉 blob 对象
          }
        });
      },
      // 查询API
      qryListAPI() {
        this.loading = true;
        let params = {
          UserID: this.userid == undefined ? "" : this.userid,
          pageindex: this.pagination.current,
          pagesize: this.pagination.pageSize,
        };

        this.axios
          .post("/usermember/GetUserMemberList", params)
          .then((res) => {
            if (res.data) {
              this.pagination.total = res.total;
              this.loading = false;
              this.data = res.data;
            }
          });
      },
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys;
      },
      // 勾选删除
      checkDelete() {
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        const that = this;
        this.$confirm({
          title: "批量删除",
          content: "您要确定要删除勾选数据吗?",
          onOk() {
            const idList = [];
            that.selectedRowKeys.forEach((element) => {
              idList.push({ ID: element });
            });
            that.axios
              .post("/UserMember/BatDeleteUserMember", {
                UserList: idList,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success("删除成功");
                  that.qryListAPI();
                }
              });
          },
        });
      },
      orderexportbatchshow() {
        this.exportbatchvisible = true;
      }
    },
    watch: {
      $route(to, from) {
        if (this.$route.params.name === "user") {
          this.userid = this.$route.params.userid;
          this.qryListAPI();
        }
      },
    },
    //首次加载
    created() {
      if (this.$route.params.name === "user") {
        this.userid = this.$route.params.userid;
      }
      this.qryListAPI();
      const array = JSON.parse(sessionStorage.RoleID);
      const roleID = [55, 56, 57, 80, 81];
      var isRole = roleID.filter(function (item) {
        return array.indexOf(item) != -1
      });
      //功能权限获取
      isRole.forEach(element => {
        this["role" + element] = true;
      });

    },
  };
</script>

<style>
  .red {
    color: rgb(255, 0, 0);
  }

  .marr10 {
    margin-right: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/usermanage/usermanage.vue